(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapsible-text-image"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.faq-block-content').hide();
    $('.faq-block').first().addClass('active').find('.faq-block-content').show();
    $('.faq-image[data-faq-index="0"]').addClass('active');

    $('.faq-block-title').each(function (index) {
      $(this).on('click', function () {
        const $clickedBlock = $(this).closest('.faq-block');
        const isActive = $clickedBlock.hasClass('active');
        $('.faq-block').removeClass('active')
          .find('.faq-icon').text('+');

        $('.faq-block-content').stop(true, true).slideUp(300);
        $('.faq-image').removeClass('active');

        if (!isActive) {
          $clickedBlock.addClass('active')
            .find('.faq-icon').text('−');

          $clickedBlock.find('.faq-block-content').stop(true, true).slideDown(300);
          $(`.faq-image[data-faq-index="${index}"]`).addClass('active');
        } else {
          $('.faq-image[data-faq-index="0"]').addClass('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collapsible-text-image"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function () {
    $('.faq-block-content').hide();
    $('.faq-block').first().addClass('active').find('.faq-block-content').show();
    $('.faq-image[data-faq-index="0"]').addClass('active');

    $('.faq-block-title').each(function (index) {
      $(this).on('click', function () {
        const $clickedBlock = $(this).closest('.faq-block');
        const isActive = $clickedBlock.hasClass('active');
        $('.faq-block').removeClass('active')
          .find('.faq-icon').text('+');

        $('.faq-block-content').stop(true, true).slideUp(300);
        $('.faq-image').removeClass('active');

        if (!isActive) {
          $clickedBlock.addClass('active')
            .find('.faq-icon').text('−');

          $clickedBlock.find('.faq-block-content').stop(true, true).slideDown(300);
          $(`.faq-image[data-faq-index="${index}"]`).addClass('active');
        } else {
          $('.faq-image[data-faq-index="0"]').addClass('active');
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
